// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"6372fb09","894":"94ec06fd"}[chunkId] + ".chunk.js";
};